import React from 'react';
import { KpiTile } from '~analytics-components/kpi-tile';
import { formatDurationSeconds } from '../format-duration';
import { BoxedTileRow } from './boxed-tile-row';
import type { KpiFormProps } from '../types';

/** Number form: a single formatted count with an optional trend row. A duration
 * metric (`isDuration`) renders as a compact `2m 18s` via the shared formatter,
 * so a seconds value reads identically to the Ask AI tiles instead of a bare,
 * unit-less number. A currency metric (`isCurrency`) renders as `$N` via the
 * tile's own formatting (mutually exclusive with `isDuration`). `invertTrend`
 * marks a lower-is-better metric (e.g. churn's account deletions) so the trend
 * colour flips. */
export const NumberForm: React.FC<KpiFormProps> = ({
    data,
    invertTrend,
    boxed,
}) => {
    if (data.form !== 'number') return null;
    const value = data.isDuration
        ? formatDurationSeconds(data.value)
        : data.value;
    const tile = {
        value,
        isCurrency: data.isCurrency,
        trend: data.trend,
        invertTrend,
    };
    if (boxed) {
        return <BoxedTileRow highlightIndex={0} tiles={[tile]} />;
    }
    return <KpiTile kpi={{ ...tile, flat: true }} />;
};
